module.exports = __webpack_public_path__ + "static/media/taizo-yamamoto-desk-wide.9713f968.jpeg";